import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import {
  VideoContainer,
  VideoContent,
  VideoTitle,
  VideoWrapper,
  VideoElement,
  NavigationButtons,
  NavigationButton,
  DisabledButton,
  SuggestedTitle,
  SuggestedGrid,
  SuggestedItem,
  SuggestedText,
  SuggestedTextTitle,
} from "../Styles/StyledPodcast.js"; // Adjust this import path if needed
import pv1 from "../Images/pv8.mp4";
import pv2 from "../Images/pv7.mp4";
import pv3 from "../Images/pv6.mp4";
import pv4 from "../Images/pv5.mp4";
import pv5 from "../Images/pv1.mp4";
import pv6 from "../Images/pv5.mp4";
import pv7 from "../Images/pv6.mp4";
import pv8 from "../Images/pv7.mp4";
import pv9 from "../Images/pv1.mp4";
import pv10 from "../Images/pv2.mp4";
import pv11 from "../Images/pv6.mp4";
import pv12 from "../Images/pv7.mp4";

// Define podcasts array with proper references to imported video files
const podcasts = [
  { id: 1, title: "Gail Schwartz - Habitat for Humanity", videoUrl: pv1 },
  { id: 2, title: "Bradley Nelson - CMO Insights", videoUrl: pv2 },
  { id: 3, title: "Peter Kloman - Collector's Group", videoUrl: pv3 },
  { id: 4, title: "Sarah Johnson - Real Estate Innovations", videoUrl: pv4 },
  { id: 5, title: "John Doe - Urban Development", videoUrl: pv5 },
  { id: 6, title: "Emma Watson - Sustainable Housing", videoUrl: pv6 },
  { id: 7, title: "Chris Evans - Market Trends", videoUrl: pv7 },
  { id: 8, title: "Olivia Brown - Housing Challenges", videoUrl: pv8 },
  { id: 9, title: "David Green - Real Estate Tech", videoUrl: pv9 },
  { id: 10, title: "Laura Harris - Smart Cities", videoUrl: pv10 },
  { id: 11, title: "Tom Richards - Green Building", videoUrl: pv11 },
  { id: 12, title: "Sophia Lee - Investment Strategies", videoUrl: pv12 },
];

const VideoPage = () => {
  const { podcastId } = useParams();
  const [currentPodcast, setCurrentPodcast] = useState(null);

  useEffect(() => {
    const podcast = podcasts.find((p) => p.id === parseInt(podcastId, 10));
    setCurrentPodcast(podcast);
  }, [podcastId]);

  if (!currentPodcast) return <div>Loading...</div>;

  const currentIndex = podcasts.indexOf(currentPodcast);
  const prevPodcast = podcasts[currentIndex - 1];
  const nextPodcast = podcasts[currentIndex + 1];

  return (
    <VideoContainer>
      <VideoContent>
        <VideoTitle>{currentPodcast.title}</VideoTitle>

        <VideoWrapper>
          <VideoElement controls>
            <source src={currentPodcast.videoUrl} type="video/mp4" />
            Your browser does not support the video tag.
          </VideoElement>
        </VideoWrapper>

        <NavigationButtons>
          {prevPodcast ? (
            <NavigationButton to={`/podcast/${prevPodcast.id}`}>Previous</NavigationButton>
          ) : (
            <DisabledButton>Previous</DisabledButton>
          )}
          {nextPodcast ? (
            <NavigationButton to={`/podcast/${nextPodcast.id}`}>Next</NavigationButton>
          ) : (
            <DisabledButton>Next</DisabledButton>
          )}
        </NavigationButtons>

        <div className="mt-12">
          <SuggestedTitle>More Episodes</SuggestedTitle>
          <SuggestedGrid>
            {podcasts.map((podcast) => (
              <SuggestedItem key={podcast.id}>
                <Link to={`/podcast/${podcast.id}`}>
                  <video className="suggested-video w-full h-auto" controls>
                    <source src={podcast.videoUrl} type="video/mp4" />
                    Your browser does not support the video tag.
                  </video>
                  <SuggestedText>
                    <SuggestedTextTitle>{podcast.title}</SuggestedTextTitle>
                  </SuggestedText>
                </Link>
              </SuggestedItem>
            ))}
          </SuggestedGrid>
        </div>
      </VideoContent>
    </VideoContainer>
  );
};

export default VideoPage;
